import { tokenize } from "~/lib/square.js";
import axios from "~/axios";

const $axios = axios();

export default function (processorLabel) {
  switch (processorLabel) {
    case "square":
      return SquarePaymentProcessor;
    case "none":
    default:
      return NoPaymentProcessor;
  }
}

const SquarePaymentProcessor = {
  async submit(data) {
    try {
      let requestData = {
        formData: data.subscriber,
      };

      requestData.sourceId = await tokenize(data.card);
      requestData.formData.project_id = data.baker.id;
      requestData.formData.accepted_terms_of_service = true;

      const responseData = await submitPayment(requestData);

      if (responseData && responseData.data.success === true) {
        return true;
      } else {
        return false;
      }
    } catch (e) {
      console.log("ERROR", e);
      return false;
    }
  },
};

const NoPaymentProcessor = {
  async submit(data) {
    try {
      let requestData = {
        formData: data.subscriber,
      };

      requestData.formData.project_id = data.baker.id;
      requestData.formData.accepted_terms_of_service = true;

      const responseData = await submitPayment(requestData);

      if (responseData && responseData.data.success === true) {
        return true;
      } else {
        return false;
      }
    } catch (e) {
      return false;
    }
  },
};

const submitPayment = async function (data) {
  const body = JSON.stringify(data);

  try {
    return await $axios.post("/api/subscribe", body, {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    });
  } catch (e) {
    console.log("error", e);
    return false;
  }
};
